import Vue from 'vue';
// import * as constants from '../constants';

// const nms = [ constants.NAMESPACE, 'store', 'mutations' ].join('/');
// const log = require('debug')('@mycure/vue-plugins/' + nms);

/// imports and local declarations
/**
 * @typedef {import('./state').default} State
 * @typedef {import('./state').Medicine} Medicine
 */

/**
 * @param {State} state
 * @param {Object} obj
 * @param {boolean} [obj.upsert=true]
 * @param {Medicine[]} obj.items
 */
export function updateInMedicines (state, obj) {
  const { items, upsert } = obj;
  const list = state.medicines;
  items.forEach(item => {
    if (item.createdBy) item = { ...item, type: 'custom' };
    // find existing
    const index = list.findIndex(i => i.id === item.id);

    // update existing (inherit patient details)
    if (~index) {
      return Vue.set(list, index, item);
    }

    // add to list
    if (upsert) list.push(item);
  });
}

/**
 * @param {State} state
 * @param {Object} obj
 * @param {boolean} [obj.upsert=true]
 * @param {Medicine[]} obj.items
 */
export function updateInFavoriteMedicines (state, obj) {
  const { items, upsert } = obj;
  const list = state.favoriteMedicines;
  items.forEach(item => {
    item = { ...item, type: 'favorite' };
    // find existing
    const index = list.findIndex(i => i.id === item.id);

    // update existing (inherit patient details)
    if (~index) {
      return Vue.set(list, index, item);
    }

    // add to list
    if (upsert) list.push(item);
  });
}
